export const links = [
    {
        id: 'all',
        title: 'Все кейсы',
        href: '/cases',
    },
    {
        id: 'development',
        title: 'разработка',
        href: '/cases/development',
    },
    {
        id: 'marketing',
        title: 'маркетинг',
        href: '/cases/marketing',
    },
    {
        id: 'products',
        title: 'продукты',
        href: '/cases/products',
    },
];

export //keys - принимает 4 ключа: all, marketing, development, products = привет typescript
const listNewProjects = [
    {
        router: '/cases/development/pochtabank',
        newImg: '/images/pic/cases-list-images/pochtabank.jpg',
        oldImg: '/images/svg/projects/projects__img20.png',
        video: '/video/videoPochtabank.mp4',
        icons: [{ icon: '/images/svg/cases-list-icons/pochtabankIcon.svg' }],
        title: 'Новый сайт для Почта Банка',
        description:
            // eslint-disable-next-line max-len
            'Перенесли сайт на&nbsp;новую платформу с&nbsp;облачной архитектурой и&nbsp;создали конструктор для управления контентом',
        keys: ['development'],
    },
    {
        router: '/cases/development/frt-service',
        newImg: '/images/pic/cases-list-images/frt-service.jpg',
        video: '/video/videoFrtService.mp4',
        title: 'Сервис для обманутых дольщиков на&nbsp;Госуслугах',
        description: 'Интегрировали сервис для облегчения получения компенсаций на&nbsp;госпортал',
        keys: ['development'],
    },
    {
        router: '/cases/development/aimed',
        newImg: '/images/pic/aimed/aimed.png',
        video: '/video/videoAimed.mp4',
        title: 'Платформа для диагностики пациентов с&nbsp;помощью&nbsp;ИИ',
        description:
            // eslint-disable-next-line max-len
            'Разработали высоконагруженную платформу для конкурсов AI&rsquo;m Finder и&nbsp;AI&rsquo;m Doctor и&nbsp;сформировали уникальные датасеты для обучения российских ИИ-систем, которые станут основой системы поддержки принятия врачебных решений.',
        keys: ['development'],
    },
    {
        router: '/cases/development/teboil',
        newImg: '/images/pic/cases-list-images/teboil.jpg',
        video: '/video/videoTeboil.mp4',
        title: 'Разработка e‑commerce проекта для&nbsp;бренда Teboil',
        description:
            // eslint-disable-next-line max-len
            'За&nbsp;4&nbsp;месяца разработали интернет-магазин для&nbsp;производителя автомобильных масел, интегрировав его с&nbsp;несколькими внешними системами',
        keys: ['development'],
    },
    {
        router: '/cases/marketing/sk10',
        newImg: '/images/pic/ck10/ck10.png',
        video: '/video/videosk10.mp4',
        title: 'Лидогенерация в&nbsp;недвижимости: привлекли 4600 лидов на&nbsp;покупку квартир',
        description:
            // eslint-disable-next-line max-len
            'Выстроили устойчивую систему получения лидов за&nbsp;счет тестирования гипотез: в&nbsp;5&nbsp;раз снизили стоимость лида и&nbsp;в&nbsp;3&nbsp;раза увеличили их&nbsp;объём.',
        keys: ['marketing'],
    },
    {
        router: '/cases/development/new-rec',
        newImg: '/images/pic/new-rec/rec.jpg',
        video: '/video/osumk.mp4',
        title: 'Омниканальная система коммуникаций для Российского экспортного центра',
        description:
            // eslint-disable-next-line max-len
            'Внедрили в&nbsp;работу Российского экспортного центра омниканальную систему маркетинговых коммуникации, которая позволяет автоматизировать взаимодействие с&nbsp;пользователями портала &laquo;Мой экспорт&raquo;.',
        keys: ['development'],
    },
    {
        router: '/cases/marketing/felix',
        newImg: '/images/pic/cases-list-images/felix.png',
        oldImg: '',
        video: '/video/videoFelix.mp4',
        title: 'Увеличили на 230% количество подписчиков для бренда FELIX',
        description:
            'Создали активное комьюнити, повысили лояльность к продукции компании «Тосол-Синтез» ' +
            'в социальных сетях за счет вовлекающего контента, спецформатов и четкой стратегии продвижения',
        keys: ['marketing'],
    },
    {
        router: '/cases/development/fondrt',
        newImg: '/images/pic/cases-list-images/fondrt.jpg',
        video: '/video/videoFrt.mp4',
        title: 'Развитие сайта Фонда развития территорий',
        description:
            'Усовершенствовали онлайн-сервисы для дольщиков и&nbsp;интегрировали сайт с&nbsp;порталом Госуслуг',
        keys: ['development'],
    },
    {
        router: '/cases/marketing/skolkovo',
        oldImg: '/images/svg/projects/projects__img3.png',
        newImg: '/images/pic/cases-list-images/skolkovo12.jpg',
        video: '/video/videoSkolkovo.mp4',
        title: 'Технопарк «Сколково»',
        description:
            // eslint-disable-next-line max-len
            'Одновременно продвигали 12&nbsp;проектов и&nbsp;выполнили 100% KPI по&nbsp;каждому за&nbsp;счет точной сегментации и&nbsp;таргетинга',
        keys: ['marketing'],
    },
    {
        router: '/cases/marketing/otp-bank',
        newImg: '/images/pic/cases-list-images/otpbank.jpg',
        video: '/video/video/videoOtpbank.mp4',
        title: 'Узкие ключи и&nbsp;контентное SEO: кейс ОТП&nbsp;Банка',
        description:
            // eslint-disable-next-line max-len
            'Увеличили небрендовый поисковый трафик по&nbsp;ключевым банковским услугам и&nbsp;добились высоких позиций в&nbsp;выдаче',
        keys: ['marketing'],
    },
    {
        router: '/cases/marketing/avenu',
        newImg: '/images/svg/projects/projects__img22.png',
        video: '/video/video/videoAvenu.mp4',
        title: 'Сеть медицинских центров АВЕНЮ',
        description: 'Контекстная реклама для медицинских центров АВЕНЮ',
        keys: ['marketing'],
    },
    {
        router: '/cases/development/dev-rec/',
        newImg: '/images/pic/cases-list-images/rosexpocenter.jpg',
        video: '/video/video/videoExpocenter.mp4',
        title: 'РЭЦ',
        description:
            // eslint-disable-next-line max-len
            'Модернизация сайта и&nbsp;внутреннего портала со&nbsp;сложной архитектурой и&nbsp;круглосуточная техническая поддержка',
        keys: ['development'],
    },
    {
        router: '/cases/development/gapresource',
        newImg: '/images/pic/cases-list-images/gapresurs.jpg',
        video: '/video/video/videoGapresurs.mp4',
        title: 'Мультиязычный сайт для агрохолдинга &laquo;Ресурс&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Спроектировали функциональный и&nbsp;адаптивный корпоративный сайт на&nbsp;4&nbsp;языках с&nbsp;возможностями SEO-продвижения',
        keys: ['development'],
    },
    {
        router: '/cases/development/rukami/',
        newImg: '/images/pic/cases-list-images/rukami.jpg',
        video: '/video/video/videoRukami.mp4',
        icons: [
            { icon: '/images/svg/cases-list-icons/rukamiIcon.svg' },
            { icon: '/images/svg/cases-list-icons/rukamiSecondIcon.svg' },
        ],
        title: 'Международный киберфестиваль RUKAMI',
        description:
            // eslint-disable-next-line max-len
            'Разработали интерактивную highload-платформу и&nbsp;обеспечили бесперебойную работу для 100 тысяч пользователей',
        keys: ['development'],
    },
    {
        router: '/cases/marketing/bonum',
        newImg: '/images/pic/cases-list-images/bonum.jpg',
        video: '/video/videoBonum.mp4',
        title: 'Увеличили продажи спецтехники: кейс завода Bonum',
        description:
            // eslint-disable-next-line max-len
            'Снизили стоимость конверсий за счет распределения рекламного трафика по&nbsp;каналам и постоянного тестирования гипотез',
        keys: ['marketing'],
    },
    {
        router: '/cases/marketing/seo-fintech',
        newImg: '/images/pic/cases-list-images/seofintech.jpg',
        video: '/video/video/videoFintech.mp4',
        title: 'SEO для финтеха',
        description:
            'Типичные ошибки и&nbsp;практические советы по&nbsp;поисковой оптимизации сайтов финансовых компаний',
        keys: [] as string[],
    },
    {
        router: '/cases/marketing/medved',
        newImg: '/images/pic/cases-list-images/medved.jpg',
        title: 'Медведь',
        video: '/video/video/videoMedved.mp4',
        description: 'SEO для интернет-магазина спортивных товаров',
        keys: ['marketing'],
    },
    {
        router: '/cases/marketing/garantiinyi-fond',
        newImg: '/images/pic/cases-list-images/garantfond.jpg',
        title: 'Контент-маркетинг для Гарантийного фонда Ростовской области',
        description: 'SMM-стратегия для продвижения сообществ клиента из&nbsp;госсектора',
        keys: ['marketing'],
    },
    {
        router: '/cases/products/2pdf/',
        oldImg: '/images/svg/projects/projects__img10.png',
        title: '2pdf.com',
        video: '/video/video/video2pdf.mp4',
        description:
            'Создание и&nbsp;запуск высоконагруженного сервиса для конвертации pdf-файлов на&nbsp;международный рынок',
        keys: ['products'],
    },
    {
        router: '/cases/development/upgreat/',
        oldImg: '/images/svg/projects/projects__img16.svg',
        title: 'Платформа для конкурса по&nbsp;разработке искусственного интеллекта',
        description:
            // eslint-disable-next-line max-len
            'Разработали и&nbsp;запустили высокотехнологичную платформу для&nbsp;конкурса Up&nbsp;Great ПРО//ЧТЕНИЕ с&nbsp;открытым кодом',
        keys: ['development'],
    },
    {
        router: '/cases/marketing/yookassa',
        newImg: '/images/pic/cases-list-images/ukassa.jpg',
        title: 'Юкасса',
        description: 'Сохранить небрендовый трафик и&nbsp;минимизировать потери позиций сайта',
        keys: [] as string[],
    },
    {
        router: '/cases/marketing/skolkovo-kids',
        newImg: '/images/pic/cases-list-images/skolkovodeti.jpg',
        title: 'Дети в&nbsp;Сколково',
        video: '/video/skolkovodeti.mp4',
        description: 'Как сделать сообщество эффективной площадкой для бренда',
        keys: ['marketing'],
    },
    {
        router: '/cases/marketing/nanoteh/',
        oldImg: '/images/svg/projects/projects__img11.png',
        title: 'Двукратный рост трафика и&nbsp;видимости сайта РМ&nbsp;&laquo;Нанотех&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Увеличили посещение сайта в&nbsp;2&nbsp;раза и&nbsp;вывели более 1000 фраз из&nbsp;узкой семантики в&nbsp;топ-10 за&nbsp;6&nbsp;месяцев',
        keys: ['marketing'],
    },
    {
        router: '/cases/development/gge/',
        oldImg: '/images/svg/projects/projects__img13.png',
        title: 'Улучшение сайта Главгосэкспертизы России',
        description:
            // eslint-disable-next-line max-len
            'Провели масштабные работы по&nbsp;переносу проекта на&nbsp;новый сервер, создали новые и&nbsp;доработали старые функции сайта',
        keys: ['development'],
    },
    {
        router: '/cases/products/converter/',
        oldImg: '/images/svg/projects/projects__img2.png',
        title: 'Onlineconvertfree.com',
        description: 'Создали платформу мирового уровня для&nbsp;онлайн-конвертации 250+ форматов',
        keys: ['products'],
    },
    {
        router: '/cases/development/techleaders/',
        oldImg: '/images/svg/projects/projects__img6.png',
        title: 'Экосистема форума «Глобальное технологическое лидерство»',
        description:
            // eslint-disable-next-line max-len
            'Развернули сложную экосистему на&nbsp;сайте форума с&nbsp;интеграцией технологических инструментов для моментальной передачи информации',
        keys: ['development'],
    },
    {
        router: '/cases/development/letovo/',
        oldImg: '/images/svg/projects/projects__img14.png',
        title: 'Модернизация сайта международной школы &laquo;Летово&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Сделали 7&nbsp;сложных интеграций, обновили дизайн, модернизировали личный кабинет, разработали и&nbsp;запустили англоязычную версию сайта',
        keys: ['development'],
    },
    {
        router: '/cases/development/zkhfoundation/',
        oldImg: '/images/svg/projects/projects__img12.png',
        title: 'Комплексное обновление бренда Фонда ЖКХ ',
        description:
            // eslint-disable-next-line max-len
            'Заменили систему управления сайтом и&nbsp;разработали новый брендбук для&nbsp;коммуникационных материалов по&nbsp;ключевым направлениям Фонда',
        keys: ['development'],
    },
    {
        router: '/cases/marketing/mid/',
        oldImg: '/images/svg/projects/projects__img15.png',
        title: 'Привлечение абитуриентов в&nbsp;колледж через онлайн-каналы',
        description:
            // eslint-disable-next-line max-len
            'Помогли колледжу МИД России собрать в&nbsp;3&nbsp;раза больше заявок на&nbsp;поступление с&nbsp;помощью таргета и&nbsp;контекста с&nbsp;охватом более 1,5 млн человек',
        keys: ['marketing'],
    },
    {
        router: '/cases/marketing/adventureland/',
        oldImg: '/images/svg/projects/projects__img18.png',
        title: 'Продвижение сообщества AdventureLand Технопарка &laquo;Сколково&raquo;',
        description:
            // eslint-disable-next-line max-len
            'Провели эффективные рекламные кампании по&nbsp;привлечению стартапов и&nbsp;инвесторов в&nbsp;крупнейший технопарк Европы',
        keys: ['marketing'],
    },
    {
        router: '/cases/products/linkbuilder/',
        oldImg: '/images/svg/projects/projects__img1.png',
        title: 'Linkbuilder.Ai',
        description:
            'Автоматический сервис по&nbsp;увеличению ссылочной массы для владельцев бизнеса',
        keys: ['products'],
    },
    {
        router: '/cases/marketing/mts-invest/',
        oldImg: '/images/svg/projects/projects__img8.png',
        title: 'МТС Инвестиции',
        description: 'Техническая и поисковая оптимизация страниц сайта',
        keys: ['marketing'],
    },
    {
        router: '/cases/development/krdv/',
        oldImg: '/images/svg/projects/projects__img9.png',
        title: 'Корпорация развития Дальнего Востока',
        description: 'Разработка инновационных сервисов для&nbsp;системы личных кабинетов',
        keys: ['development'],
    },
    {
        router: '/cases/development/gens/',
        oldImg: '/images/svg/projects/projects__img4.png',
        title: 'Акселератор «GenerationS»',
        description: 'Cоздание платформы для проведения отбора в&nbsp;корпоративные акселераторы',
        keys: ['development'],
    },
    {
        router: '/cases/marketing/rec/',
        oldImg: '/images/svg/projects/projects__img5.png',
        title: 'Российский экспортный центр',
        description:
            // eslint-disable-next-line max-len
            'С&nbsp;помощью контекстной рекламы и&nbsp;поисковой оптимизации повысить охват и&nbsp;рост целевого трафика',
        keys: ['marketing'],
    },
    // {
    //     newImg: avenu,
    //     video: videoAvenu,
    //     title: 'Контекстная реклама для медицинских центров АВЕНЮ',
    //     description:
    // eslint-disable-next-line max-len
    //         'Как получать лиды в&nbsp;конкурентной нише и&nbsp;сколько клиентов удалось привлечь в&nbsp;результате ведения проекта.',
    // },
];
